import React, { useState } from "react";
import { Link } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL || "https://api.lastiqo.com/api";

const SifremiUnuttum = () => {
  const [username, setUsername] = useState("");
  const [durum, setDurum] = useState(null); // null | "basarili" | "hata"
  const [mesaj, setMesaj] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      setDurum("hata");
      setMesaj("Kullanıcı adı zorunludur.");
      return;
    }

    setYukleniyor(true);
    setDurum(null);
    try {
      const res = await fetch(`${API_URL}/auth/sifremi-unuttum`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username.trim() }),
      });
      const data = await res.json();
      setDurum("basarili");
      setMesaj(data.mesaj || "Şifre sıfırlama linki gönderildi.");
    } catch {
      setDurum("hata");
      setMesaj("Sunucuya bağlanılamadı. Lütfen tekrar deneyin.");
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <div style={logoCircle}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.5" />
                <circle cx="12" cy="12" r="3" fill="#fff" />
                <line x1="12" y1="3" x2="12" y2="7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="12" y1="17" x2="12" y2="21" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="3" y1="12" x2="7" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="17" y1="12" x2="21" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <span style={{ fontSize: "1.3rem", fontWeight: 400, color: "#1a1a2e" }}>
              LastiQo <strong style={{ color: "#e63946" }}>Lastik</strong>
            </span>
          </div>
        </div>

        {/* İkon */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{
            width: "64px", height: "64px", borderRadius: "50%",
            background: "linear-gradient(135deg, #fff5f5, #fde8ea)",
            border: "2px solid #fecaca",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="1.8">
              <rect x="2" y="7" width="20" height="14" rx="2" />
              <path d="M16 7V5a4 4 0 0 0-8 0v2" />
              <circle cx="12" cy="14" r="1.5" fill="#e63946" stroke="none" />
              <line x1="12" y1="15.5" x2="12" y2="18" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        <h1 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1a1a2e", textAlign: "center", marginBottom: "8px" }}>
          Şifremi Unuttum
        </h1>
        <p style={{ color: "#888", fontSize: "0.88rem", textAlign: "center", marginBottom: "28px", lineHeight: 1.6 }}>
          Kayıtlı kullanıcı adınızı girin. Şifre sıfırlama bağlantısı göndereceğiz.
        </p>

        {durum === "basarili" ? (
          <div style={bildirimStyle("#f0fdf4", "#bbf7d0", "#16a34a")}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>{mesaj}</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>KULLANICI ADI</label>
              <div style={{ position: "relative" }}>
                <span style={ikonStyle}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => { setUsername(e.target.value); setDurum(null); }}
                  placeholder="kullaniciadi"
                  style={inputStyle(durum === "hata")}
                  onFocus={(e) => e.target.style.borderColor = "#e63946"}
                  onBlur={(e) => e.target.style.borderColor = durum === "hata" ? "#e63946" : "#e8e8e8"}
                />
              </div>
            </div>

            {durum === "hata" && (
              <div style={bildirimStyle("#fff5f5", "#fecaca", "#e63946")}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <span>{mesaj}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={yukleniyor}
              style={butonStyle(yukleniyor)}
            >
              {yukleniyor ? (
                <>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                    style={{ animation: "spin 1s linear infinite" }}>
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                  </svg>
                  Gönderiliyor...
                </>
              ) : "Sıfırlama Linki Gönder"}
            </button>
          </form>
        )}

        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Link to="/login" style={{ color: "#e63946", fontSize: "0.85rem", textDecoration: "none", fontWeight: 500, display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Giriş sayfasına dön
          </Link>
        </div>
      </div>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

// ── Stiller ──────────────────────────────────────────────────────────────────
const sayfaStyle = {
  minHeight: "100vh",
  background: "linear-gradient(145deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "'Segoe UI', sans-serif", padding: "20px",
};

const kartStyle = {
  background: "#fff", borderRadius: "20px", padding: "48px 44px",
  width: "100%", maxWidth: "440px",
  boxShadow: "0 24px 64px rgba(0,0,0,0.3)",
};

const logoCircle = {
  width: "36px", height: "36px", borderRadius: "50%",
  background: "linear-gradient(135deg, #1a1a2e 60%, #e63946)",
  display: "flex", alignItems: "center", justifyContent: "center",
};

const labelStyle = {
  display: "block", fontSize: "0.78rem", fontWeight: 600,
  color: "#444", marginBottom: "8px", letterSpacing: "0.3px",
};

const ikonStyle = {
  position: "absolute", left: "13px", top: "50%",
  transform: "translateY(-50%)", color: "#bbb",
  display: "flex", alignItems: "center",
};

const inputStyle = (hataVar) => ({
  width: "100%", boxSizing: "border-box",
  padding: "12px 14px 12px 38px",
  border: `1.5px solid ${hataVar ? "#e63946" : "#e8e8e8"}`,
  borderRadius: "10px", fontSize: "0.9rem", color: "#333",
  outline: "none", background: "#fafafa", transition: "border-color 0.2s",
});

const butonStyle = (disabled) => ({
  width: "100%", padding: "13px",
  background: disabled ? "#c0392b" : "linear-gradient(135deg, #e63946, #c0392b)",
  color: "#fff", border: "none", borderRadius: "10px",
  fontSize: "0.93rem", fontWeight: 600,
  cursor: disabled ? "not-allowed" : "pointer",
  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
});

const bildirimStyle = (bg, border, color) => ({
  background: bg, border: `1px solid ${border}`, borderRadius: "10px",
  padding: "12px 16px", marginBottom: "16px", color,
  fontSize: "0.85rem", display: "flex", alignItems: "flex-start", gap: "10px",
  lineHeight: 1.5,
});

export default SifremiUnuttum;
